import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import InviteUserScreen from '../components/screens/users2/InviteUserScreen';

export default function UserInvite(props) {
  return (
    <Layout headerTitle="User Invite">
      <PageContainer id="user_invite">
        <InviteUserScreen props={props} />
      </PageContainer>
    </Layout>
  );
}
